(function () {
  "use strict";

  var configurator = document.querySelector("[data-rehair-custom-configurator]");
  if (!configurator) return;

  document.body.classList.add("rehair-custom-builder-page");

  var params = new URLSearchParams(window.location.search);
  var path = params.get("path") || "known-specs";
  var firstOrderConfirmed = {};
  var adviceRequested = {};
  var selectionProperties = function () { return {}; };
  var firstOrderChoiceKeys = [
    "Base Type",
    "Skin Base Technique",
    "Base size (inch)",
    "Length (inch)",
    "Color",
    "Hair Type",
    "Gray Hair Type",
    "Gray Hair Percentage",
    "Density",
    "Wave/Curl",
    "Hair Direction",
    "Front Contour",
    "Bleaching Knots",
    "The Extra Front Lace/Skin",
    "Hair Pre-Cut",
    "Rush Order Service",
    "Add Clips",
    "Upload",
  ];
  var pathLabels = {
    "first-order": "First custom order: we will use your priorities to recommend compatible specifications.",
    "known-specs": "Known specifications: enter the technical details you already use.",
    reorder: "Reorder: include your previous ReHair order number or order email for verification.",
    duplicate: "Duplicate an old unit: upload references and use the pickup service if a physical sample is needed.",
  };
  var notice = configurator.querySelector("[data-custom-path-notice]");

  function canonicalChoiceKey(value) {
    var key = String(value || "")
      .replace(/^properties\[/, "")
      .replace(/^options\[/, "")
      .replace(/\]$/, "")
      .replace(/^_custom_/, "")
      .replace(/^_/, "")
      .trim();
    if (/^bleach knots$/i.test(key)) return "Bleaching Knots";
    if (/^upload/i.test(key)) return "Upload";
    return key;
  }

  function markFirstOrderConfirmed(fieldOrKey) {
    if (path !== "first-order") return;
    if (typeof fieldOrKey !== "string") {
      if (!fieldOrKey || fieldOrKey.type === "hidden" || /^properties\[/.test(fieldOrKey.name || "")) return;
      var flowUi = document.querySelector("[data-rehair-custom-flow-ui]");
      var activeStep = flowUi && flowUi.getAttribute("data-flow-current-step");
      if (!flowUi || !/^[1-3]$/.test(String(activeStep || ""))) return;
      var sourceGroup = getGroupForElement(fieldOrKey);
      if (sourceGroup && sourceGroup.classList.contains("rehair-custom-flow-hidden")) return;
    }
    var rawKey = typeof fieldOrKey === "string"
      ? fieldOrKey
      : fieldOrKey && (
          fieldOrKey.getAttribute("aria-label") ||
          fieldOrKey.getAttribute("name") ||
          fieldOrKey.getAttribute("field-name")
        );
    var key = canonicalChoiceKey(rawKey);
    delete adviceRequested[key];
    if (firstOrderChoiceKeys.indexOf(key) !== -1) firstOrderConfirmed[key] = true;
  }

  function shouldKeepFirstOrderChoice(key) {
    var canonicalKey = canonicalChoiceKey(key);
    return !adviceRequested[canonicalKey] && (path !== "first-order" || !!firstOrderConfirmed[canonicalKey]);
  }

  function setPath(nextPath) {
    if (nextPath !== path) { firstOrderConfirmed = {}; adviceRequested = {}; }
    path = nextPath;
    if (notice) {
      notice.textContent = pathLabels[path] || pathLabels["known-specs"];
      notice.hidden = false;
    }
    try {
      var nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set("path", path);
      window.history.replaceState({}, "", nextUrl.toString());
    } catch (_error) {}
  }

  setPath(path);

  var storageKey = "rehair_custom_quote_attribution";
  var attributionKeys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gclid",
    "gbraid",
    "wbraid",
  ];
  var attribution = {};

  try {
    attribution = JSON.parse(window.sessionStorage.getItem(storageKey) || "{}");
  } catch (_error) {
    attribution = {};
  }

  attributionKeys.forEach(function (key) {
    var value = params.get(key);
    if (value && value.length <= 512) attribution[key] = value;
  });
  try {
    window.sessionStorage.setItem(storageKey, JSON.stringify(attribution));
  } catch (_error) {}

  var routeNames = {
    "first-order": "First custom order",
    "known-specs": "Known specifications",
    reorder: "Reorder an existing ReHair unit",
    duplicate: "Duplicate an old unit",
  };

  function currentRouteName() {
    return routeNames[path] || routeNames["known-specs"];
  }

  // Aris names some fields with stray spaces (e.g. " Gray Hair Type"); reuse that exact name so the quote
  // does not list the same choice twice.
  function formPropertyName(form, name) {
    var found = name;
    form.querySelectorAll('[name^="properties["]').forEach(function (field) {
      var match = String(field.name || "").match(/^properties\[(.*)\]$/);
      if (match && match[1] !== name && match[1].trim() === name) found = match[1];
    });
    return found;
  }

  function upsertReadableProperty(form, name, value) {
    name = formPropertyName(form, name);
    var selector = '[name="properties[' + name + ']"]';
    var field = form.querySelector(selector);
    if (!field) {
      field = document.createElement("input");
      field.type = "hidden";
      field.name = "properties[" + name + "]";
      form.appendChild(field);
    }
    field.value = value;
  }

  function attachProperties() {
    var obsoleteNames = attributionKeys
      .concat(["landing_url", "custom_path"])
      .reduce(function (list, key) {
        list.push("properties[_" + key + "]");
        list.push("properties[_custom_" + key + "]");
        return list;
      }, []);

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      obsoleteNames.forEach(function (name) {
        var field = form.querySelector('[name="' + name + '"]');
        if (field) field.remove();
      });
      upsertReadableProperty(form, "Order Route", currentRouteName());
      var resolved = selectionProperties();
      Object.keys(resolved).forEach(function (key) {
        upsertReadableProperty(form, key, resolved[key]);
      });
      var baseType = document.querySelector(
        'select[name="options[Base Type]"], [aria-label="options[Base Type]"]'
      );
      if (baseType && /other|not sure/i.test(String(baseType.value || ""))) {
        upsertReadableProperty(form, "Base Guidance", "Specialist recommendation requested");
      } else {
        var guidance = form.querySelector('[name="properties[Base Guidance]"]');
        if (guidance) guidance.remove();
      }

      form.querySelectorAll('[name^="properties["]').forEach(function (field) {
        var match = String(field.name || "").match(/^properties\[(.*)\]$/);
        var key = canonicalChoiceKey(match && match[1]);
        if (firstOrderChoiceKeys.indexOf(key) === -1) return;
        if (path === "first-order" && !shouldKeepFirstOrderChoice(key) && !adviceRequested[key]) {
          field.disabled = true;
          field.setAttribute("data-rehair-first-order-disabled", "true");
          return;
        }
        if (field.getAttribute("data-rehair-first-order-disabled") === "true") {
          field.disabled = false;
          field.removeAttribute("data-rehair-first-order-disabled");
        }
      });

      var skinTechniqueProperty = form.querySelector('[name="properties[Skin Base Technique]"]');
      if (skinTechniqueProperty) {
        skinTechniqueProperty.disabled = !baseType || !/full skin/i.test(String(baseType.value || "").trim()) ||
          skinTechniqueProperty.getAttribute("data-rehair-first-order-disabled") === "true";
      }

      var grayTypeField = document.querySelector(
        '[aria-label="Gray Hair Type"], [aria-label=" Gray Hair Type"]'
      );
      var grayPercentageProperty = form.querySelector('[name="properties[Gray Hair Percentage]"]');
      if (grayPercentageProperty) {
        // Stay disabled while unconfirmed on the first-order route, otherwise the hidden default is sent.
        grayPercentageProperty.disabled = (!!grayTypeField && /no gray hair/i.test(String(grayTypeField.value || ""))) ||
          grayPercentageProperty.getAttribute("data-rehair-first-order-disabled") === "true";
      }
    });

    var productId = window.__st && window.__st.rid;
    var products = window.omgrfq_productCollection;
    var product = products && productId && products[productId];
    if (!product) return;

    product.properties = Object.assign({}, product.properties || {});
    attributionKeys.concat(["landing_url", "custom_path"]).forEach(function (key) {
      delete product.properties["_" + key];
      delete product.properties["_custom_" + key];
    });
    product.properties["Order Route"] = currentRouteName();

    var selectedBase = document.querySelector(
      'select[name="options[Base Type]"], [aria-label="options[Base Type]"]'
    );
    if (selectedBase && /other|not sure/i.test(String(selectedBase.value || ""))) {
      product.properties["Base Guidance"] = "Specialist recommendation requested";
    } else {
      delete product.properties["Base Guidance"];
    }

    if (!selectedBase || !/full skin/i.test(String(selectedBase.value || "").trim())) {
      delete product.properties["Skin Base Technique"];
      delete product.properties["_custom_Skin Base Technique"];
    }

    var selectedGrayType = document.querySelector(
      '[aria-label="Gray Hair Type"], [aria-label=" Gray Hair Type"]'
    );
    if (selectedGrayType && /no gray hair/i.test(String(selectedGrayType.value || ""))) {
      delete product.properties["Gray Hair Percentage"];
      delete product.properties["_custom_Gray Hair Percentage"];
    }

    document.querySelectorAll('form[action*="/cart/add"] [name^="properties["]').forEach(function (field) {
      var match = String(field.name || "").match(/^properties\[(.*)\]$/);
      var propertyName = match && match[1];
      var key = canonicalChoiceKey(propertyName);
      if (!propertyName || firstOrderChoiceKeys.indexOf(key) === -1) return;
      if (path === "first-order" && !shouldKeepFirstOrderChoice(key)) {
        delete product.properties[propertyName];
        delete product.properties["_custom_" + propertyName];
        return;
      }
      if (!field.disabled && field.value) product.properties[propertyName] = field.value;
    });
    // Explicit advice must replace any prior/default value in the plugin payload.
    var resolved = selectionProperties();
    var cartForm = document.querySelector('form[action*="/cart/add"]');
    Object.keys(resolved).forEach(function (key) {
      var name = cartForm ? formPropertyName(cartForm, key) : key;
      if (name !== key) delete product.properties[key];
      product.properties[name] = resolved[key];
    });
  }

  function addStyles() {
    if (document.getElementById("rehair-custom-flow-styles")) return;
    var style = document.createElement("style");
    style.id = "rehair-custom-flow-styles";
    style.textContent =
      ".rehair-custom-flow-ui{margin-top:22px;padding:18px;border:1px solid rgba(39,35,45,.16);background:#f7f3ec}" +
      ".rehair-custom-flow-ui__eyebrow{margin:0 0 8px;font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:#6b5a35}" +
      ".rehair-custom-flow-ui h2{margin:0 0 8px;font-size:22px}" +
      ".rehair-custom-flow-ui__path-list{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;margin:14px 0}" +
      ".rehair-custom-flow-ui__path,.rehair-custom-flow-ui__button{border:1px solid #27232d;background:#fff;color:#27232d;padding:11px 13px;cursor:pointer;font:inherit;text-align:left}" +
      ".rehair-custom-flow-ui__path[aria-pressed=true]{background:#27232d;color:#fff}" +
      ".rehair-custom-flow-ui__path strong,.rehair-custom-flow-ui__path small{display:block}" +
      ".rehair-custom-flow-ui__path small{margin-top:5px;line-height:1.35;opacity:.75}" +
      ".rehair-custom-flow-ui__progress{display:flex;gap:6px;flex-wrap:wrap;margin:14px 0}" +
      ".rehair-custom-flow-ui__step{display:grid;grid-template-columns:30px minmax(0,1fr);grid-template-rows:auto auto;column-gap:8px;align-items:center;border:1px solid rgba(39,35,45,.16);background:#fff;color:#69636d;padding:10px 9px;font:inherit;cursor:pointer;text-align:left;min-width:0}" +
      ".rehair-custom-flow-ui__step[aria-current=step]{border-color:#27232d;color:#27232d;background:#f7f3ec}" +
      ".rehair-custom-flow-ui__step[data-flow-complete=true]{color:#27232d}" +
      ".rehair-custom-flow-ui__number{grid-row:1 / span 2;display:grid;place-items:center;width:28px;height:28px;border:1px solid currentColor;border-radius:50%;font-size:12px;font-weight:700}" +
      ".rehair-custom-flow-ui__step[aria-current=step] .rehair-custom-flow-ui__number,.rehair-custom-flow-ui__step[data-flow-complete=true] .rehair-custom-flow-ui__number{color:#fff;background:#27232d}" +
      ".rehair-custom-flow-ui__label{font-size:13px;font-weight:700;line-height:1.2}" +
      ".rehair-custom-flow-ui__step small{grid-column:2;margin-top:3px;color:#69636d;font-size:11px;line-height:1.25}" +
      ".rehair-custom-flow-ui__instruction{margin:12px 0 0;padding:10px 12px;color:#27232d;background:#f1eef8;border-left:3px solid #27232d;font-size:14px;line-height:1.45}" +
      ".rehair-custom-flow-quote-hidden{display:none!important}" +
      ".rehair-custom-flow-ui__step[aria-current=step]{color:#27232d;font-weight:700}" +
      ".rehair-custom-flow-ui__actions{display:flex;justify-content:space-between;gap:10px;margin-top:14px}" +
      ".rehair-custom-flow-ui__button--primary{background:#27232d;color:#fff;text-align:center}" +
      ".rehair-custom-flow-ui__summary{margin-top:14px;padding-top:14px;border-top:1px solid rgba(39,35,45,.16)}" +
      ".rehair-custom-flow-ui__summary dl{display:grid;grid-template-columns:1fr 1fr;gap:7px;margin:0}" +
      ".rehair-custom-flow-ui__summary dt{font-weight:600}.rehair-custom-flow-ui__summary dd{margin:0;color:#625c55}" +
      ".rehair-custom-flow-hidden{display:none!important}" +
      "@media(max-width:989px){.rehair-custom-flow-ui__progress{grid-template-columns:repeat(3,minmax(0,1fr))}}@media(max-width:749px){.rehair-custom-flow-ui__path-list{grid-template-columns:1fr}.rehair-custom-flow-ui__progress{grid-template-columns:repeat(2,minmax(0,1fr));gap:7px}.rehair-custom-flow-ui__step{min-height:68px;padding:9px 8px}.rehair-custom-flow-ui__step:last-child{grid-column:1 / -1}.rehair-custom-flow-ui__label{font-size:12px}.rehair-custom-flow-ui__step small{font-size:10px}.rehair-custom-flow-ui__summary dl{grid-template-columns:1fr}.rehair-custom-flow-ui{padding:14px}}";
    document.head.appendChild(style);
  }

  function getGroupForElement(element) {
    if (!element) return null;
    if (element.matches('select[name^="options["]')) {
      return element.closest(".main-product__block-variant_picker") || element.closest("variant-picker") || element.parentElement;
    }
    if (element.type === "file") return element.closest(".avp-option") || element.closest(".app-avis-product-options-block");
    return element.closest(".avp-option") || element.closest(".avp-option-container") || element.parentElement;
  }

  function normalizeOptionLabel(value) {
    return String(value || "").replace(/^options\[/, "").replace(/\]$/, "").trim();
  }

  function findGroups() {
    var groups = {};

    function addField(field, fallbackLabel) {
      if (!field) return;
      var group = getGroupForElement(field);
      // Aris renders some selects before filling name/aria-label; its field-name attribute is always set.
      var label = normalizeOptionLabel(
        field.getAttribute("aria-label") || field.getAttribute("name") || field.getAttribute("field-name") || fallbackLabel
      );
      // Avis now labels this option "Bleach Knots"; the flow lists it as "Bleaching Knots".
      if (/^bleach knots$/i.test(label)) label = "Bleaching Knots";
      if (group && label) groups[label] = group;
    }

    var optionContainer = document.querySelector(".app-avis-product-options-block");
    if (optionContainer) {
      optionContainer
        .querySelectorAll(
          'select[aria-label], input[aria-label], textarea[aria-label], select[name], input[name], textarea[name], [field-name], input[type="file"]'
        )
        .forEach(function (field) {
          addField(field);
        });
    }

    var baseType = document.querySelector(
      'select[name="options[Base Type]"], [aria-label="options[Base Type]"]'
    );
    addField(baseType, "Base Type");

    var upload = document.querySelector('input[type="file"][name*="Upload"]');
    if (upload) {
      groups.Upload = getGroupForElement(upload);
      addField(upload, "Upload");
    }

    return groups;
  }

  function applyWomenPalette() {
    if (configurator.getAttribute("data-custom-gender") !== "women") return;
    var color = document.querySelector('select[aria-label="Color"]');
    if (!color || color.getAttribute("data-rehair-women-palette") === "true") return;
    var shades = [
      "#NB", "#1B", "#1", "#2", "#2A", "#4", "#6", "#7C", "#8", "#10",
      "#12", "#14", "#16", "#18", "#22", "#24", "#27", "#30", "#33", "#60",
      "#99J", "#130", "#530", "#613", "#614", "#4-8-18", "#18-22", "#6-8-613", "#GREY", "#T4/8/60",
      "#R24AL", "#R25AL", "#R26AL", "#R27AL", "#R28AL", "#R29AL", "#R30AL", "#R31AL", "#R32AL"
    ];
    color.innerHTML = "";
    var match = document.createElement("option");
    match.value = "Match hair sample or photo";
    match.textContent = "Match hair sample or photo";
    color.appendChild(match);
    shades.forEach(function (shade) {
      var option = document.createElement("option");
      option.value = shade;
      option.textContent = shade;
      color.appendChild(option);
    });
    // Avis shows "Color Name/Color Code" when Color contains "OTHERS".
    var other = document.createElement("option");
    other.value = "OTHERS";
    other.textContent = "Other shade (enter name or code)";
    color.appendChild(other);
    color.setAttribute("data-rehair-women-palette", "true");
    var group = getGroupForElement(color);
    if (group && !group.querySelector("[data-rehair-women-palette-note]")) {
      var note = document.createElement("small");
      note.setAttribute("data-rehair-women-palette-note", "");
      note.textContent = "Women's custom shade codes. Send a photo or physical sample when matching is critical.";
      note.style.display = "block";
      note.style.marginTop = "6px";
      note.style.opacity = "0.72";
      group.appendChild(note);
    }
  }


  function baseChoiceMeta(value) {
    var text = String(value || "");
    var lower = text.toLowerCase();
    if (/match.*old|duplicate/.test(lower)) return { kind: "sample", title: "Match my old unit", description: "Choose this when we are copying a unit you already wear." };
    if (/swiss.*lace/.test(lower)) return { kind: "lace", title: text, description: "A finer lace option when a light, delicate construction is preferred." };
    if (/french.*lace.*skin|lace.*skin|australia|q6/.test(lower)) return { kind: "hybrid", title: text.replace(/\s*\/\s*/g, " / "), description: "Combines a lace area with a skin bonding perimeter." };
    if (/full.*french.*lace|french.*lace/.test(lower)) return { kind: "lace", title: text, description: "A breathable lace construction with flexible styling." };
    if (/skin|poly/.test(lower)) return { kind: "skin", title: text, description: "A smooth bonding surface; confirm the exact skin technique below." };
    if (/mono/.test(lower)) return { kind: "mono", title: text, description: "A structured construction for repeated handling and support." };
    if (/frontal|front/.test(lower)) return { kind: "frontal", title: text, description: "Coverage focused on the front or hairline area." };
    if (/other|not sure/.test(lower)) return { kind: "help", title: "Not sure / another base", description: "Choose this and tell us what you need; a specialist will review it." };
    return { kind: "base", title: text, description: "Choose this construction if it matches your current specification." };
  }

  function buildBaseChooser(ui, groups) {
    function currentBaseSelect() {
      return document.querySelector(
        'select[name="options[Base Type]"], [aria-label="options[Base Type]"]'
      );
    }

    var baseSelect = currentBaseSelect();
    if (!baseSelect) return null;

    var sourceGroup = groups["Base Type"] || getGroupForElement(baseSelect);
    if (!sourceGroup || sourceGroup.querySelector("[data-rehair-base-chooser]")) return null;

    var options = [];
    Array.prototype.forEach.call(baseSelect.options || [], function (option) {
      var value = String(option.value || "").trim();
      if (!value || /^-?\s*please select/i.test(value)) return;
      var meta = baseChoiceMeta(value);
      options.push({ value: value, meta: meta });
    });

    var familyOrder = ["lace", "skin", "hybrid", "mono", "frontal", "base", "sample", "help"];
    var familyCopy = {
      lace: { title: "Lace base", description: "French or Swiss lace." },
      skin: { title: "Skin base", description: "Smooth bonding surface." },
      hybrid: { title: "Lace + skin hybrid", description: "Lace center + skin perimeter." },
      mono: { title: "Mono base", description: "Structured and supportive." },
      frontal: { title: "Frontal base", description: "Front or hairline coverage." },
      base: { title: "Other listed base", description: "Match an existing specification." },
      sample: { title: "Match my old unit", description: "Copy an existing unit." },
      help: { title: "Not sure", description: "Let a specialist recommend." },
    };
    var families = {};
    options.forEach(function (option) {
      var key = option.meta.kind;
      if (!families[key]) families[key] = [];
      families[key].push(option);
    });

    var chooser = document.createElement("section");
    chooser.className = "rehair-base-chooser";
    chooser.setAttribute("data-rehair-base-chooser", "");
    chooser.innerHTML =
      '<div class="rehair-base-chooser__heading"><div><p class="rehair-base-chooser__eyebrow">Important fit choice</p><h3>Choose your base construction</h3><p>Choose the closest family. Lace and hybrid will ask for one exact construction.</p></div><span>Required</span></div>' +
      '<div class="rehair-base-chooser__grid" aria-label="Base construction families"></div>' +
      '<div class="rehair-base-chooser__subchoices" data-base-subchoices hidden></div>' +
      '<p class="rehair-base-chooser__note">Not sure? Choose the specialist option instead of guessing.</p>';

    var grid = chooser.querySelector(".rehair-base-chooser__grid");
    familyOrder.forEach(function (kind) {
      var familyOptions = families[kind];
      if (!familyOptions || !familyOptions.length) return;
      var copy = familyCopy[kind] || familyCopy.base;
      var button = document.createElement("button");
      button.type = "button";
      button.className = "rehair-base-card";
      button.setAttribute("aria-pressed", "false");
      button.setAttribute("data-base-family", kind);
      button.innerHTML =
        '<span class="rehair-base-card__visual rehair-base-card__visual--' + kind + '" aria-hidden="true"><i></i></span>' +
        '<span class="rehair-base-card__copy"><strong>' + copy.title + '</strong><small>' + copy.description + '</small></span>' +
        '<span class="rehair-base-card__check" aria-hidden="true">✓</span>';
      grid.appendChild(button);
    });

    sourceGroup.parentNode.insertBefore(chooser, sourceGroup);
    sourceGroup.classList.add("rehair-base-type-source");

    var confirmed = false;
    var activeFamily = "";

    function chooseExact(value, kind) {
      var liveSelect = currentBaseSelect();
      if (!liveSelect) return;
      markFirstOrderConfirmed("Base Type");
      liveSelect.value = value;
      liveSelect.dispatchEvent(new Event("input", { bubbles: true }));
      liveSelect.dispatchEvent(new Event("change", { bubbles: true }));
      activeFamily = kind;
      confirmed = true;
      renderState();
      attachProperties();
    }

    function renderSubchoices(kind) {
      var panel = chooser.querySelector("[data-base-subchoices]");
      var familyOptions = families[kind] || [];
      if (familyOptions.length <= 1) {
        panel.hidden = true;
        panel.innerHTML = "";
        return;
      }
      var copy = familyCopy[kind] || familyCopy.base;
      panel.hidden = false;
      panel.innerHTML = '<strong>Choose the exact ' + copy.title.toLowerCase() + ':</strong><div></div>';
      var row = panel.querySelector("div");
      familyOptions.forEach(function (option) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "rehair-base-subchoice";
        button.setAttribute("data-base-value", option.value);
        button.setAttribute("data-base-kind", kind);
        button.setAttribute("aria-pressed", confirmed && currentBaseSelect() && currentBaseSelect().value === option.value ? "true" : "false");
        button.textContent = option.value.replace(/\s*\/\s*/g, " / ");
        row.appendChild(button);
      });
    }

    function renderState() {
      chooser.querySelectorAll("[data-base-family]").forEach(function (button) {
        button.setAttribute("aria-pressed", button.getAttribute("data-base-family") === activeFamily ? "true" : "false");
      });
      chooser.querySelectorAll("[data-base-value]").forEach(function (button) {
        var liveSelect = currentBaseSelect();
        button.setAttribute("aria-pressed", confirmed && liveSelect && button.getAttribute("data-base-value") === liveSelect.value ? "true" : "false");
      });
    }

    chooser.addEventListener("click", function (event) {
      var exact = event.target.closest("[data-base-value]");
      if (exact) {
        chooseExact(exact.getAttribute("data-base-value"), exact.getAttribute("data-base-kind"));
        return;
      }

      var familyButton = event.target.closest("[data-base-family]");
      if (!familyButton) return;
      var kind = familyButton.getAttribute("data-base-family");
      var familyOptions = families[kind] || [];
      activeFamily = kind;
      confirmed = false;
      renderSubchoices(kind);
      renderState();
      if (familyOptions.length === 1) {
        chooseExact(familyOptions[0].value, kind);
      } else {
        var firstExact = chooser.querySelector("[data-base-value]");
        if (firstExact) firstExact.focus();
      }
    });

    document.addEventListener("change", function (event) {
      if (!event.target.matches('select[name="options[Base Type]"], [aria-label="options[Base Type]"]')) return;
      var liveSelect = currentBaseSelect();
      if (!liveSelect) return;
      var selected = options.filter(function (option) { return option.value === liveSelect.value; })[0];
      if (selected) activeFamily = selected.meta.kind;
      confirmed = true;
      renderSubchoices(activeFamily);
      renderState();
      attachProperties();
    });

    renderState();

    return {
      isConfirmed: function () { return confirmed; },
      focus: function () {
        var active = chooser.querySelector('[data-base-family="' + activeFamily + '"]');
        var first = active || chooser.querySelector("[data-base-family]");
        if (first) first.focus();
      },
    };
  }

  function buildFlow() {
    if (document.querySelector("[data-rehair-custom-flow-ui]")) return;
    addStyles();

    var groups = findGroups();
    var integrated = /^(women|men)$/.test(
      configurator.getAttribute("data-custom-gender") || ""
    );
    var ui = document.createElement("section");
    ui.className = "rehair-custom-flow-ui";
    ui.setAttribute("data-rehair-custom-flow-ui", "");
    ui.innerHTML =
      '<p class="rehair-custom-flow-ui__eyebrow">Guided custom request</p>' +
      '<h2 data-flow-title>Choose your starting path</h2>' +
      '<p data-flow-help>Choose the route that best describes your order.</p>' +
      '<div class="rehair-custom-flow-ui__path-list" data-flow-paths>' +
        '<button type="button" class="rehair-custom-flow-ui__path" data-flow-path="first-order"><strong>First custom order</strong><small>Guide me through the important choices.</small></button>' +
        '<button type="button" class="rehair-custom-flow-ui__path" data-flow-path="known-specs"><strong>I know my specs</strong><small>Enter the technical details I already use.</small></button>' +
        '<button type="button" class="rehair-custom-flow-ui__path" data-flow-path="duplicate"><strong>Duplicate an old unit</strong><small>Use photos, a template or an old system.</small></button>' +
      '</div>' +
      '<div class="rehair-custom-flow-ui__progress" role="list" aria-label="Custom request progress" data-flow-progress>' +
        '<button type="button" class="rehair-custom-flow-ui__step" data-flow-step="0"><span class="rehair-custom-flow-ui__number">1</span><span class="rehair-custom-flow-ui__label">Start</span><small>Choose your route</small></button>' +
        '<button type="button" class="rehair-custom-flow-ui__step" data-flow-step="1"><span class="rehair-custom-flow-ui__number">2</span><span class="rehair-custom-flow-ui__label">Coverage &amp; base</span><small>Set the fit</small></button>' +
        '<button type="button" class="rehair-custom-flow-ui__step" data-flow-step="2"><span class="rehair-custom-flow-ui__number">3</span><span class="rehair-custom-flow-ui__label">Hair details</span><small>Match the hair</small></button>' +
        '<button type="button" class="rehair-custom-flow-ui__step" data-flow-step="3"><span class="rehair-custom-flow-ui__number">4</span><span class="rehair-custom-flow-ui__label">Finishing &amp; services</span><small>Add optional details</small></button>' +
        '<button type="button" class="rehair-custom-flow-ui__step" data-flow-step="4"><span class="rehair-custom-flow-ui__number">5</span><span class="rehair-custom-flow-ui__label">Review &amp; quote</span><small>Check everything</small></button>' +
      '</div>' +
      '<p class="rehair-custom-flow-ui__instruction" data-flow-instruction>Step 1 of 5 — Choose one route to begin.</p>' +
      '<div class="rehair-custom-flow-ui__fields" data-flow-fields hidden></div>' +
      '<div class="rehair-custom-flow-ui__summary" data-flow-summary hidden></div>' +
      '<div class="rehair-custom-flow-ui__quote" data-flow-quote hidden></div>' +
      '<p class="rehair-custom-flow-ui__error" data-flow-error hidden></p>' +
      '<div class="rehair-custom-flow-ui__actions"><button type="button" class="rehair-custom-flow-ui__button" data-flow-back>Back</button><button type="button" class="rehair-custom-flow-ui__button rehair-custom-flow-ui__button--primary" data-flow-next>Continue</button></div>';

    var productInfo = document.querySelector(".m-main-product--info .m-product-info--wrapper");
    var priceBlock = productInfo && productInfo.querySelector(".product-block-group--price");
    var priceSection = priceBlock && priceBlock.closest(".main-product__block");
    if (integrated && productInfo) {
      document.body.classList.add("rehair-custom-builder-page--integrated");
      configurator.classList.add("rehair-custom-configurator--source-hidden");
      if (priceSection && priceSection.parentNode) priceSection.parentNode.insertBefore(ui, priceSection.nextSibling);
      else productInfo.insertBefore(ui, productInfo.firstChild);
    } else {
      var header = configurator.querySelector(".rehair-custom-configurator__container");
      if (header) header.appendChild(ui);
      else configurator.appendChild(ui);
    }

    var fieldsSlot = ui.querySelector("[data-flow-fields]");
    var quoteSlot = ui.querySelector("[data-flow-quote]");
    if (integrated && fieldsSlot) {
      var variantBlock = document.querySelector(".main-product__block-variant_picker");
      var avisBlock = document.querySelector(".app-avis-product-options-block");
      avisBlock = avisBlock && avisBlock.closest(".main-product__block");
      if (variantBlock) fieldsSlot.appendChild(variantBlock);
      if (avisBlock) fieldsSlot.appendChild(avisBlock);
      var buyBlock = document.querySelector(".main-product__block-buy_buttons");
      if (buyBlock && quoteSlot) quoteSlot.appendChild(buyBlock);
    }

    groups = findGroups();
    var baseChooser = buildBaseChooser(ui, groups);

    function keepPriceSummaryAboveBuilder() {
      if (!integrated || !productInfo || !ui.parentNode) return;
      var candidates = Array.prototype.slice.call(
        productInfo.querySelectorAll(".main-product__block-price")
      );
      var visiblePrice = candidates.filter(function (block) {
        return block.offsetHeight > 0 && window.getComputedStyle(block).display !== "none";
      })[0];
      if (visiblePrice && visiblePrice.nextSibling !== ui) {
        productInfo.insertBefore(visiblePrice, ui);
      }
    }

    keepPriceSummaryAboveBuilder();

    var step = 0;
    var highestStep = 0;
    var reviewedSteps = {};
    var stepLabels = ["Choose your starting path", "Confirm coverage and base", "Match the hair", "Choose finishing and services", "Review before requesting a quote"];
    var stepHelp = ["Choose one route to begin.", "Check the visible fit choices before continuing.", "Confirm length, color, hair type, density and texture.", "Add optional finishing, service and reference details.", "Review the confirmed choices below. No payment is taken here."];
    var fit = ["Base Type", "Skin Base Technique", "Base size (inch)"];
    var hair = ["Length (inch)", "Color", "Hair Type", "Density", "Wave/Curl"];
    // Avis follow-up text fields: Avis shows/hides them by its own conditions; the flow only keeps them on their parent's step.
    var followUps = {
      1: ["Describe Base Type"],
      2: ["Custom Length", "Color Name/Color Code", "Describe Custom Density Percentage for Different Zone"],
      3: ["Describe Custom Gray Hair Percentage for Different Zone"]
    };
    var services = ["Highlight", "Gray Hair Type", "Gray Hair Percentage", "Hair Direction", "Front Contour", "Bleaching Knots", "The Extra Front Lace/Skin", "Hair Pre-Cut", "Rush Order Service", "Add Clips", "Upload"];

    function setGroupVisible(group, visible) {
      if (!group) return;
      group.classList.toggle("rehair-custom-flow-hidden", !visible);
      group.setAttribute("aria-hidden", visible ? "false" : "true");
    }

    function escapeHtml(value) {
      return String(value || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }

    function fieldFor(key) {
      var group = groups[key];
      if (!group) return null;
      return group.querySelector("select[aria-label], input[aria-label], textarea[aria-label], select[name], input[name], textarea[name], [field-name]");
    }

    function isApplicable(key) {
      if (key === "Skin Base Technique") {
        var baseType = fieldFor("Base Type");
        return !!baseType && /full skin/i.test(String(baseType.value || "").trim());
      }
      if (key === "Gray Hair Percentage") {
        var grayType = fieldFor("Gray Hair Type");
        return !grayType || !/no gray hair/i.test(String(grayType.value || ""));
      }
      return true;
    }

    var requiredChoices = fit.concat(hair);
    function hasValue(field) {
      return !!field && !!String(field.value || "").trim() && !/please select/i.test(field.value);
    }
    function unresolved(keys) {
      return keys.filter(function (key) {
        if (!isApplicable(key) || !fieldFor(key)) return false;
        return !adviceRequested[key] && (!shouldKeepFirstOrderChoice(key) || !hasValue(fieldFor(key)));
      });
    }
    selectionProperties = function () {
      var out = {};
      if (path !== "first-order") return out;
      requiredChoices.concat(services).forEach(function (key) {
        if (key === "Upload" || !isApplicable(key) || !fieldFor(key)) return;
        // Use the field's own Aris name ("Bleach Knots" for men, "Bleaching Knots" for women, " Gray Hair Type")
        // so the quote does not list the same choice twice under two names.
        var rawName = fieldFor(key).getAttribute("name") || fieldFor(key).getAttribute("field-name") || key;
        var propertyKey = /^options\[/.test(rawName) ? key : rawName;
        if (adviceRequested[key]) out[propertyKey] = "Please recommend — not yet confirmed";
        else if (shouldKeepFirstOrderChoice(key) && hasValue(fieldFor(key))) out[propertyKey] = String(fieldFor(key).value).trim();
      });
      return out;
    };
    function renderDecisions() {
      requiredChoices.concat(services).forEach(function (key) {
        var group = groups[key];
        // The existing base-family chooser already requires an explicit choice.
        if (!group || key === "Upload" || key === "Base Type" || !fieldFor(key)) return;
        var box = group.querySelector("[data-choice-decision]");
        if (!box) { box = document.createElement("div"); box.setAttribute("data-choice-decision", key); group.appendChild(box); }
        box.hidden = path !== "first-order" || !isApplicable(key);
        if (box.hidden) return;
        var status = adviceRequested[key] ? "Specialist advice requested" : shouldKeepFirstOrderChoice(key) && hasValue(fieldFor(key)) ? "Confirmed: " + fieldFor(key).value : "Not confirmed yet";
        box.style.cssText = "margin:8px 0 12px;display:flex;gap:8px;flex-wrap:wrap;align-items:center;font-size:14px";
        box.innerHTML = '<span style="width:100%" role="status">' + escapeHtml(status) + '</span><button type="button" data-choice-confirm="' + escapeHtml(key) + '" style="min-height:40px;padding:8px 12px;border:1px solid #777;background:white;font-size:14px">Confirm current choice</button><button type="button" data-choice-advice="' + escapeHtml(key) + '" style="min-height:40px;padding:8px 12px;border:1px solid #777;background:white;font-size:14px">Please recommend</button>';
      });
    }
    function checkChoices(keys) {
      var missing = unresolved(keys);
      if (!missing.length) return true;
      var error = ui.querySelector("[data-flow-error]");
      error.textContent = "Please confirm a choice or request advice for: " + missing.join(", ") + ".";
      error.hidden = false;
      error.setAttribute("role", "alert");
      return false;
    }
    document.addEventListener("click", function (event) {
      var button = event.target.closest("[data-choice-confirm], [data-choice-advice]");
      if (!button || !ui.contains(button)) return;
      var key = button.getAttribute("data-choice-confirm") || button.getAttribute("data-choice-advice");
      if (button.hasAttribute("data-choice-advice")) { adviceRequested[key] = true; delete firstOrderConfirmed[key]; }
      else if (hasValue(fieldFor(key))) { firstOrderConfirmed[key] = true; delete adviceRequested[key]; }
      attachProperties(); renderDecisions(); updateSummary();
    });
    // Recheck at submission, including after a user revisits earlier steps.
    window.rehairValidateQuoteChoices = function () {
      if (checkChoices(requiredChoices)) { attachProperties(); return true; }
      applyStep(unresolved(fit).length ? 1 : 2, true);
      checkChoices(requiredChoices);
      return false;
    };

    function summaryGroup(title, editStep, keys) {
      var rows = [];
      var specialistReview = false;
      var hasGuidanceRow = false;
      keys.forEach(function (key) {
        if (key === "Upload" || !isApplicable(key)) return;
        var field = fieldFor(key);
        if (!field) return;
        if (adviceRequested[key]) {
          rows.push("<dt>" + escapeHtml(normalizeOptionLabel(key)) + "</dt><dd>Please recommend — not yet confirmed</dd>");
          return;
        }
        if (!shouldKeepFirstOrderChoice(key)) {
          specialistReview = true;
          return;
        }
        var value = String(field.value || "").trim();
        if (!value || value === "- Please Select -") return;
        if (path === "first-order" && key === "Base Type" && /other|not sure/i.test(value)) {
          rows.push("<dt>Base guidance</dt><dd>Specialist recommendation requested</dd>");
          hasGuidanceRow = true;
          return;
        }
        rows.push("<dt>" + escapeHtml(normalizeOptionLabel(key)) + "</dt><dd>" + escapeHtml(value) + "</dd>");
      });
      if (specialistReview && !hasGuidanceRow) {
        rows.push("<dt>Optional details</dt><dd>Not selected</dd>");
      }
      if (!rows.length) return "";
      return '<section class="rehair-custom-flow-ui__summary-group"><div><strong>' + escapeHtml(title) + '</strong><button type="button" data-flow-edit="' + editStep + '">Edit</button></div><dl>' + rows.join("") + "</dl></section>";
    }

    function updateSummary() {
      var summary = ui.querySelector("[data-flow-summary]");
      if (!summary) return;
      var content =
        summaryGroup("Coverage & base", 1, fit) +
        summaryGroup("Hair details", 2, hair) +
        summaryGroup("Finishing & services", 3, services);
      summary.innerHTML =
        '<div class="rehair-custom-flow-ui__summary-heading"><strong>Your request summary</strong><span>Use Edit to return to any section.</span></div>' +
        '<section class="rehair-custom-flow-ui__summary-group"><div><strong>Request route</strong><button type="button" data-flow-edit="0">Edit</button></div><dl><dt>Order route</dt><dd>' + escapeHtml(currentRouteName()) + '</dd></dl></section>' +
        (content || "<p>No product selections are available yet.</p>");
    }

    function currentHelp() {
      if (step === 1 && path === "duplicate") return "Upload a clear old-unit photo or template, then confirm any fit details you want to change.";
      if (step === 1 && path === "first-order") return "Confirm each fit choice, or explicitly ask for a recommendation.";
      if (step === 2 && path === "first-order") return "Change a choice or use Confirm current choice to accept it. Use Please recommend if unsure.";
      if (step === 3 && path === "first-order") return "Change a choice or use Confirm current choice to accept it. Use Please recommend if unsure. Finishing services are optional.";
      if (step === 1 && path === "known-specs") return "Enter the coverage and base specifications you already use.";
      return stepHelp[step];
    }

    function firstVisibleGroup() {
      var keys = step === 1 ? fit : step === 2 ? hair : services;
      if (step === 1 && path === "duplicate") keys = fit.concat(["Upload"]);
      for (var index = 0; index < keys.length; index += 1) {
        var group = groups[keys[index]];
        if (group && !group.classList.contains("rehair-custom-flow-hidden")) return group;
      }
      return ui;
    }

    function moveToCurrentContent() {
      var target = step === 4 ? ui.querySelector("[data-flow-summary]") : firstVisibleGroup();
      window.setTimeout(function () {
        if (target && target.scrollIntoView) target.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 80);
    }

    function placeQuoteBlock(show) {
      var block = ui.querySelector("[data-flow-quote] .main-product__block-buy_buttons") || document.querySelector(".main-product__block-buy_buttons");
      if (block && quoteSlot && block.parentNode !== quoteSlot) quoteSlot.appendChild(block);
      quoteSlot.hidden = !show;
      if (block) {
        block.classList.toggle("rehair-custom-flow-hidden", !show);
        block.setAttribute("aria-hidden", show ? "false" : "true");
      }
      document.querySelectorAll(".omgrfq-btn-quotes, .omgrfq-btn-add-quotes").forEach(function (button) {
        button.classList.toggle("rehair-custom-flow-quote-hidden", !show);
        button.setAttribute("aria-hidden", show ? "false" : "true");
        button.tabIndex = show ? 0 : -1;
      });
    }

    function applyStep(nextStep, shouldScroll) {
      step = Math.max(0, Math.min(4, nextStep));
      ui.setAttribute("data-flow-current-step", String(step));
      groups = findGroups();
      var help = currentHelp();
      ui.querySelector("[data-flow-title]").textContent = stepLabels[step];
      ui.querySelector("[data-flow-help]").textContent = help;
      ui.querySelector("[data-flow-instruction]").textContent = "Step " + (step + 1) + " of 5 — " + help;
      ui.querySelectorAll("[data-flow-step]").forEach(function (button) {
        var buttonStep = Number(button.getAttribute("data-flow-step"));
        button.setAttribute("aria-current", buttonStep === step ? "step" : "false");
        button.setAttribute("data-flow-complete", reviewedSteps[buttonStep] ? "true" : "false");
        button.disabled = buttonStep > highestStep;
      });
      ui.querySelectorAll("[data-flow-path]").forEach(function (button) {
        button.setAttribute("aria-pressed", button.getAttribute("data-flow-path") === path ? "true" : "false");
      });
      ui.querySelector("[data-flow-paths]").classList.toggle("rehair-custom-flow-hidden", step !== 0);
      var baseChooserElement = ui.querySelector("[data-rehair-base-chooser]");
      if (baseChooserElement) {
        baseChooserElement.classList.toggle("rehair-custom-flow-hidden", step !== 1);
        baseChooserElement.setAttribute("aria-hidden", step === 1 ? "false" : "true");
      }
      Object.keys(groups).forEach(function (key) { setGroupVisible(groups[key], false); });

      if (step === 1) {
        fit.forEach(function (key) { setGroupVisible(groups[key], isApplicable(key)); });
        if (path === "duplicate") setGroupVisible(groups.Upload, true);
      }
      if (step === 2) hair.forEach(function (key) { setGroupVisible(groups[key], true); });
      if (step === 3) services.forEach(function (key) { setGroupVisible(groups[key], isApplicable(key)); });
      (followUps[step] || []).forEach(function (key) { setGroupVisible(groups[key], true); });

      fieldsSlot.hidden = step === 0 || step === 4;
      var summary = ui.querySelector("[data-flow-summary]");
      summary.hidden = step !== 4;
      if (step === 4) updateSummary();
      placeQuoteBlock(step === 4);

      ui.querySelector("[data-flow-back]").disabled = step === 0;
      var nextButton = ui.querySelector("[data-flow-next]");
      nextButton.hidden = step === 4;
      nextButton.textContent = step === 0 ? "Start this path" : step === 3 ? "Review my choices" : "Continue — I checked this step";
      ui.querySelector("[data-flow-error]").hidden = true;
      renderDecisions();
      if (shouldScroll) moveToCurrentContent();
    }

    ui.addEventListener("click", function (event) {
      var pathButton = event.target.closest("[data-flow-path]");
      if (pathButton) {
        setPath(pathButton.getAttribute("data-flow-path"));
        reviewedSteps[0] = true;
        highestStep = Math.max(highestStep, 1);
        applyStep(1, true);
        return;
      }

      var editButton = event.target.closest("[data-flow-edit]");
      if (editButton) {
        applyStep(Number(editButton.getAttribute("data-flow-edit")), true);
        return;
      }

      var stepButton = event.target.closest("[data-flow-step]");
      if (stepButton) {
        var requestedStep = Number(stepButton.getAttribute("data-flow-step"));
        if (requestedStep <= highestStep) applyStep(requestedStep, true);
        return;
      }

      if (event.target.closest("[data-flow-back]")) {
        applyStep(step - 1, true);
        return;
      }

      if (event.target.closest("[data-flow-next]") && step < 4) {
        if (step === 1 && baseChooser && !baseChooser.isConfirmed()) {
          var error = ui.querySelector("[data-flow-error]");
          error.textContent = "Please choose a base construction, or choose Not sure / another base.";
          error.hidden = false;
          baseChooser.focus();
          return;
        }
        if ((step === 1 || step === 2) && !checkChoices(step === 1 ? fit : hair)) return;
        attachProperties();
        reviewedSteps[step] = true;
        highestStep = Math.max(highestStep, step + 1);
        applyStep(step + 1, true);
      }
    });

    // Avis stops "change" from bubbling on its selects (e.g. Gray Hair Type), so listen in the capture phase.
    document.addEventListener("change", function (event) {
      markFirstOrderConfirmed(event.target);
      renderDecisions();
      updateSummary();
      if (step === 1 || step === 3) {
        window.setTimeout(function () { applyStep(step, false); }, 0);
      }
      attachProperties();
    }, true);
    document.addEventListener("input", function (event) {
      markFirstOrderConfirmed(event.target);
      attachProperties();
    }, true);
    applyStep(0, false);

    var refreshCount = 0;
    var refreshTimer = window.setInterval(function () {
      applyWomenPalette();
      groups = findGroups();
      keepPriceSummaryAboveBuilder();
      applyStep(step, false);
      refreshCount += 1;
      if (refreshCount >= 12) window.clearInterval(refreshTimer);
    }, 900);
  }

  var started = false;
  function trackStart(event) {
    if (started || !event.target.matches("input, select, textarea")) return;
    started = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "rehair_custom_quote_start",
      shopping_path: path,
      product_id: configurator.getAttribute("data-product-id"),
    });
  }

  document.addEventListener("change", trackStart, true);
  document.addEventListener("click", function (event) {
    if (!event.target.closest(".omgrfq-btn-quotes, .omgrfq-btn-add-quotes")) return;
    attachProperties();
  });

  attachProperties();
  window.setTimeout(attachProperties, 1200);
  window.setTimeout(attachProperties, 3500);
  window.setTimeout(buildFlow, 1800);
  window.setTimeout(buildFlow, 4500);
  window.setTimeout(applyWomenPalette, 1800);
  window.setTimeout(applyWomenPalette, 4500);
})();
